
import { mapState } from 'vuex';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import axios from 'axios';
import moment from 'moment';
import Actions from './candidate-actions/index.vue';
import LinkShare from '@/components/modals/LinkShare.vue';
import MessageSend from '@/components/modals/MessageSend.vue';
import ModalAlert from '@/components/modals/ModalAlert.vue';
import Tabs from './Tabs.vue';
import Resume from './resume/Scene.vue';
import Videointerview from './videointerview/Scene.vue';
import Voicebot from './voicebot/Scene.vue';
// import ResponseTags from '@/components/response/tags/index.vue';
import VcvTags from '@/components/response/VcvTags.vue';
import ProcessNames from '@/process/names.js';
import BlockNameIndex from './blocks/BlockName';
import responsesSwitcher from './services/responsesSwitcher.ts';

import { compileTemplate } from '@/_helpers/utils.js';
import AdditionalResponse from '@/components/response/additional-response/index';

@Component({
  name: 'ResponseSceneContent',
  components: {
    AdditionalResponse,
    // ResponseTags,
    MessageSend,
    ModalAlert,
    LinkShare,
    Actions,
    Tabs,
    Resume,
    Videointerview,
    Voicebot,
    VcvTags,
    BlockNameIndex
  },
  computed: {
    ...mapState('vcvTags', ['vcv_tags_list'])
  }
})
export default class ResponseSceneContent extends Vue {
  @Prop({ default: false }) readonly loading: boolean;
  @Prop({ default: null }) readonly error: object;
  @Prop({ default: null }) readonly response: object;
  @Prop({ default: [] }) readonly responses: [];
  @Prop({ default: [] }) readonly comments: [];
  @Prop({ default: [] }) readonly history: [];
  @Prop({ default: null }) readonly voicebot: object;
  @Prop({ default: () => {} }) readonly fetch: () => {};
  @Prop({ default: () => {} }) readonly setStars: () => {};
  @Prop({ default: '' }) readonly fullName: string;

  private isSidebarDocked = true;
  private isLinkShareShown = false;
  private isMessageSendShown = false;
  private emailTemplate = {};
  private emailStatus = 0;
  private emailApiMethod = 'emailSend';
  private isSentSuccess = false;
  private isAlreadySentModalVisible = false;
  private share_template = null;
  private event_catcher = null;

  get vacancy() {
    return this.response.vacancy || {};
  }

  get vacancyPropertiesIcons() {
    // здесь дальше добавятся данные для спортмастера и/или для других клиентов (иконки прохождения этапов справа от имени)
    let icons = [];

    if (this.response.properties !== undefined) {
      const sportmaster_security_check = this.response.properties.find(x => x.code === 'sportmaster_security_check');

      if (sportmaster_security_check !== undefined) {
        icons.push(sportmaster_security_check);
      }

      return icons;
    }

    return icons;
  }

  get dateFormat() {
    return this.is_japan_locale ? 'YYYY.MM.DD' : 'DD.MM.YYYY';
  }

  get responseDate() {
    if (!this.response || !this.response.date_sent) {
      return '';
    }
    // let date = this.response.date_sent;
    let timeFormat = this.company.time_format === 12 ? 'hh:mm a' : 'HH:mm';
    const day = moment(this.response.date_sent, null, 'en');

    if (!day) {
      return '';
    }

    return day.format(`${this.dateFormat} ${timeFormat}`);
  }

  get responses_filtered_list() {
    return this.$store.getters['responses/filteredList'];
  }

  get responses_ids() {
    if (!this.responses_filtered_list) {
      return [];
    }

    return this.responses_filtered_list.map(response => response.id);
  }

  get current_response_id() {
    if (!this.response) {
      return null;
    }
    return this.response.id;
  }

  get has_prev_response() {
    return responsesSwitcher.hasResponseSwitch(
      this.responses_ids,
      this.current_response_id,
      'prev'
    );
  }

  get has_next_response() {
    return responsesSwitcher.hasResponseSwitch(
      this.responses_ids,
      this.current_response_id,
      'next'
    );
  }

  get candidate() {
    return this.response.candidate || {};
  }

  get questions() {
    return this.response.questions || [];
  }

  get starRating() {
    return this.response.star ? this.response.star.value : 0;
  }

  get tabsList() {
    return this.$store.getters['situation/response/tabsAvailable'];
  }

  get resumeLinkFile() {
    return this.response ? this.response.resume_url : null;
  }

  get resumeLinkUrl() {
    return this.response ? this.response.second_resume_url : null;
  }

  get is_japan_locale() {
    return this.$store.getters['locale/is_japan_locale'];
  }

  get fullNameToDisplay() {
    return !this.is_japan_locale
      ? [this.candidate.name, this.candidate.surname].join(' ')
      : [this.candidate.surname, this.candidate.name].join(' ');
  }

  get currentUser() {
    return this.$store.getters['user/current'] ? this.$store.getters['user/current'] : null;
  }

  get company() {
    return this.$store.getters['company/one'];
  }

  get tags() {
    /* TODO Выпилить после попадания тегов в кор функционал
    В данном случае определение возможности фильтрация по тегам
    сделана без создания прослойки компонента спецпроцесса,
    так как данный функционал должен попасть в кор продукт. */
    const vacancy = this.$store.getters['response/one'].vacancy;
    let vacancyId = vacancy ? vacancy.id : -1;

    const jtiSecondStageVacancy = 5918;
    const jtiThirdStageVacancy = 5919;
    const jtiSecondStage = jtiSecondStageVacancy === parseInt(vacancyId);
    const jtiThirdStage = jtiThirdStageVacancy === parseInt(vacancyId);
    const process = this.$store.getters['response/process'];

    return (
      process === 'danone' ||
      jtiSecondStage ||
      jtiThirdStage ||
      process === ProcessNames.SIBUR_INTERNSHIPS ||
      process === ProcessNames.BK_MANAGER ||
      process === ProcessNames.SCHLUMBERGER_CAREER ||
      process === ProcessNames.ALROSA
    );
  }

  get currentLocale() {
    return this.$store.getters['locale/current'];
  }

  @Watch('response')
  responseChanged(val) {
    if (!val) {
      return;
    }

    if (val.is_paid === 0 || val.is_paid === false) {
      this.$router.push({ path: '/responses' });
      return;
    }

    this.is_response_was_is_paid_now();
  }

  public set_event_catcher(f) {
    // приходит функция которая является ссылкой на set_active_answer в глубине другого компонента
    this.event_catcher = f;
  }
  public set_active_answer(v) {
    if (this.event_catcher !== null) {
      this.event_catcher(v);
    }
  }
  public changeSendMessageDisplay() {
    this.isMessageSendShown = !this.isMessageSendShown;
  }

  public changeLinkShareDisplay() {
    this.isLinkShareShown = !this.isLinkShareShown;
  }

  public prev_response() {
    const index = this.responses_ids.indexOf(this.current_response_id) - 1;
    this.$router.push({ path: `/responses/${this.responses_ids[index]}` });
  }

  public next_response() {
    const index = this.responses_ids.indexOf(this.current_response_id) + 1;
    this.$router.push({ path: `/responses/${this.responses_ids[index]}` });
  }

  public alreadySentModalShow() {
    this.isAlreadySentModalVisible = true;
  }

  public alreadySentModalHide() {
    this.isAlreadySentModalVisible = false;
  }

  public async statusChange(model) {
    const response = this.$store.getters['response/one'];
    // const status = response.status
    const status = model.status;
    this.emailStatus = +status.id;
    this.isSentSuccess = false;

    const templates = response.vacancy.response_status_templates;

    await this.$store.dispatch('response/saveQuietly', model).then(async () => {
      await this.$store.dispatch('response/fetchResponseHistory', response.id);

      if (window.gtag) {
        window.gtag({ event: 'response_status_change' });
      }
    });

    this.emailTemplate = templates.find(template => {
      const responseStatus = template.response_status ? template.response_status.id : null;
      return +responseStatus === this.emailStatus;
    });

    if (!this.emailTemplate || !this.emailTemplate.active) {
      return;
    }

    await this.$nextTick(); // Эта фиговина сделана потому что ранее теряется реактивность и не успевает заполниться emailTemplate. Сами компоненты карточки нуждаются в переработке.

    if (this.emailTemplate.manual) {
      this.changeSendMessageDisplay();
    } else {
      if (this.emailTemplate.already_sent) {
        this.changeSendMessageDisplay();
      } else {
        this.$notify({
          group: 'email',
          title: this.$tr('responses.sendMessage.emailTemplates.success')
        });
      }
    }
  }

  public compileTemplate(template) {
    let compiledTemplate = template;

    let params = {
      isCompileVacancy: true,
      isCompileCandidate: true,
      data: {
        company: this.company,
        user: this.currentUser,
        vacancyTitle: this.vacancy.name || '',
        candidateName: {
          name: this.candidate.name || '',
          surname: this.candidate.surname || ''
        }
      }
    };

    compiledTemplate = compileTemplate(compiledTemplate, params, this.currentLocale);

    return compiledTemplate;
  }

  public fetch_rates() {
    this.$store.dispatch('company_new/get_rates');
  }

  public is_response_was_is_paid_now() {
    if (!this.response) {
      return;
    }

    if (this.response.response_was_is_paid_now) {
      this.$noty.success(this.$tr('rates.ResponseWasWrittenOf'));
      this.fetch_rates();
    }
  }

  beforeMount() {
    axios.get(`1.0/templates/defaults/share_response_link`).then(r => {
      this.share_template = r.data.data[0];
    });
  }

  beforeDestroy() {
    this.emailTemplate = {};
    this.isMessageSendShown = false;
  }
}
